import React, { useEffect, useState } from "react";
import { Card, Switch, Form, Button, message } from "antd";

function CashboxSettings({ token }) {
  const [form] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [cashboxId, setCashboxId] = useState(null);

  useEffect(() => {
    async function fetchSettings() {
      try {
        const res = await fetch(`https://${process.env.REACT_APP_APP_URL}/api/v1/cashbox/settings?token=${token}`);
        if (!res.ok) throw new Error("Ошибка загрузки настроек");
        const data = await res.json();
        setCashboxId(data.cashbox_id);
        form.setFieldsValue({
          require_photo_for_writeoff: data.require_photo_for_writeoff,
        });
      } catch (error) {
        message.error(error.message);
      }
    }
    fetchSettings();
  }, [token, form]);

  const onFinish = async (values) => {
    if (!cashboxId) {
      return message.error("ID кассы не найден");
    }
    setLoading(true);
    try {
      const res = await fetch(`https://${process.env.REACT_APP_APP_URL}/api/v1/cashbox/settings/${cashboxId}?token=${token}`, {
        method: "PATCH",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(values),
      });
      if (!res.ok) throw new Error("Ошибка сохранения настроек");
      message.success("Настройки сохранены");
    } catch (error) {
      message.error(error.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card title="Настройки кассы" style={{ maxWidth: 500, margin: "20px auto" }}>
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Требовать фото при списании"
          name="require_photo_for_writeoff"
          valuePropName="checked"
        >
          <Switch />
        </Form.Item>
        <Form.Item>
          <Button type="primary" htmlType="submit" loading={loading}>
            Сохранить
          </Button>
        </Form.Item>
      </Form>
    </Card>
  );
}

export default CashboxSettings;
